'use strict'

export default class lsModal {
  constructor(items) {
    this.openElem = items
    this.closeElem = document.querySelectorAll('.js-lsModalClose')
    this.modalElem = document.querySelector('.js-lsModalWrap')

    this.init()
  }

  init() {
    for (let i = 0; i < this.openElem.length; i++) {
      this.openElem[i].addEventListener('click', () => {
        this.modalOpenClose('open')
      })
    }

    for (let i = 0; i < this.closeElem.length; i++) {
      this.closeElem[i].addEventListener('click', () => {
        this.modalOpenClose('close')
      })
    }
  }

  modalOpenClose(type) {
    if (type == 'open') {
      this.modalElem.classList.add('-appear')
    } else if (type == 'close') {
      this.modalElem.classList.remove('-appear')
    }
  }
}
